import { DEFAULT_LOCALE, PseudoLocale } from "../../../types/Locale"

export function getContentfulLocale(locale: string): string {
  if (PseudoLocale.isPseudoLocale(locale)) {
    return DEFAULT_LOCALE.toString()
  }
  return locale
}
